import * as React from 'react';
import PropTypes from "prop-types";
import { Autocomplete, Checkbox, FormControlLabel, Stack, TextField } from '@mui/material';
import CustomChip from './CustomChip';
import { useTranslation } from "react-i18next";
import { ExpandMoreRounded, HighlightOffRounded } from '@material-ui/icons';

const FormSegment = (props) => {
    const { t } = useTranslation();
    return (
        <Stack>
            <b>{props.segment.question}</b>
           
                {Array.from(props.segment.answers.values()).map((value, index) => {
                    return (value.type == 'radial' ? (
                    <FormControlLabel
                        id={index}
                        key={"controllLabel-" + index}
                        value="start"
                        
                        control={
                            <Checkbox
                                id={index}
                                key={"checkbox-" + index}
                                checked={props.doesSegmentContainAnswer(props.segmentIndex, value.answers[0])}
                                sx={{ '& .MuiSvgIcon-root': { fontSize: 22 } }}
                                size="small"
                                onClick={() => {
                                    if (props.doesSegmentContainAnswer(props.segmentIndex, value.answers[0])) {
                                        props.removeAnswerFromSegment(props.segmentIndex, value.answers[0]);
                                    } else {
                                        props.addAnswerToSegment(props.segmentIndex, "radial", [value.answers[0]]);
                                    }
                                }}
                            />
                        }
                        label={value.answers[0] + " (" + value.amount + ")"}
                        labelPlacement="end"
                    />
                    ) : (

                    <Autocomplete
                        id={index}
                        key={"autocomplete-" + index}
                        options={value.answers}
                        multiple
                        size="small"
                        value={props.getAutocompleteValues(props.segmentIndex)}
                        onChange={(event, value) => {
                            props.addAnswerToSegment(props.segmentIndex, "free-text", value);
                        }}
                        style={{borderRadius: '10px', marginTop: '10px'}}
                        renderTags={(value, props) =>
                            value.map((option, index) => (
                                <CustomChip
                                    id={index} 
                                    key={index}
                                    className="chip bg-dark-gray"
                                    size="small"
                                    color="#575760"
                                    deleteIcon={
                                        <HighlightOffRounded />
                                    }
                                    label={option} {...props({ index })}
                                />
                            ))
                        }
                        renderInput={(params) =>
                            <TextField
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                    borderRadius: "10px"
                                    }
                                }}
                                size="small"
                                style={{ width: '100%' }}
                                label={t('kanban.answers')} {...params} />
                        }
                        popupIcon={<ExpandMoreRounded />}
                    />
                    ))
                })}
            <br></br>
        </Stack>
    );
};

FormSegment.propTypes = {
    segmentIndex: PropTypes.number,
    segment: PropTypes.object,
    addAnswerToSegment: PropTypes.func,
    removeAnswerFromSegment: PropTypes.func,
    doesSegmentContainAnswer: PropTypes.func,
    getAutocompleteValues: PropTypes.func
};

export default FormSegment;